import React from "react";
import NavBar from "./components/navbar/navbar";
import { compiler, getInitialConfig } from "./components/compiler/compiler";
import TuringMachine from "./components/turing_machine/turing_machine";
import TuringViz from "./components/turing_viz/turing_viz";
import ExamplesContainer from "./components/examples_container/examples_container";
import Explanation from "./components/explanation/explanation";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";

class App extends React.Component {
  constructor() {
    super();
    this.initialSourceCode = `\\* Adds 1 to a binary number *\\ \n$right; \n$11011; \\\\ 27 + 1 = 28 = (11100)_2 \nin right 0 out right 0 right; \nin right 1 out right 1 right; \nin right _ out carry _ left; \nin carry 0 out halt 1 left; \nin carry 1 out carry 0 left; \nin carry _ out halt 1 left;`;
    this.machine = new TuringMachine(
      compiler(this.initialSourceCode),
      getInitialConfig(this.initialSourceCode).startState,
      getInitialConfig(this.initialSourceCode).startInput
    );
    this.state = {
      lastChanger: null,
      sourceCode: this.initialSourceCode,
      machineState: this.machine.dumpConfig(),
    };
    this.takeStep = this.takeStep.bind(this);
    this.setSourceCode = this.setSourceCode.bind(this);
    this.setMachineFromCode = this.setMachineFromCode.bind(this);
    this.setLastChanger = this.setLastChanger.bind(this);
  }

  setLastChanger(changer) {
    this.setState({ lastChanger: changer });
  }

  setSourceCode(inputSourceCode) {
    this.setState({ sourceCode: inputSourceCode }, this.setMachineFromCode);
  }

  setMachineFromCode() {
    const initialConfig = getInitialConfig(this.state.sourceCode);
    this.machine = new TuringMachine(
      compiler(this.state.sourceCode),
      initialConfig.startState,
      initialConfig.startInput
    );
    const machineState = this.machine.dumpConfig();
    this.setState({ machineState: machineState });
  }

  takeStep() {
    this.machine.step();
    const machineState = this.machine.dumpConfig();
    this.setState({ machineState: machineState });
  }

  render() {
    return (
      <React.Fragment>
        <NavBar />
        <br />
        <div className="Site-content disable-dbl-tap-zoom">
          <main className="u-container">
            <TuringViz
              machineState={this.state.machineState}
              setMachineFromCode={this.setMachineFromCode}
              takeStep={this.takeStep}
              sourceCode={this.state.sourceCode}
              setSourceCode={this.setSourceCode}
              lastChanger={this.state.lastChanger}
              setLastChanger={this.setLastChanger}
            />
            <Explanation />
            <br />
            <ExamplesContainer
              setSourceCode={this.setSourceCode}
              lastChanger={this.state.lastChanger}
              setLastChanger={this.setLastChanger}
            />
          </main>
        </div>
        <footer className="footer">
          <div className="container">
            <br />
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

export default App;
